export default function LogoMark({ className = '', size = 32 }: { className?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="TellowUp"
    >
      <rect x="2" y="2" width="36" height="36" stroke="currentColor" strokeWidth="3" fill="none" />
      <rect x="4" y="6" width="32" height="8" fill="currentColor" />
      <rect x="14" y="14" width="12" height="20" fill="currentColor" />
      <rect x="10" y="14" width="4" height="4" fill="currentColor" />
      <rect x="26" y="14" width="4" height="4" fill="currentColor" />
    </svg>
  );
}
